import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_apparel_women: FaireCategoryEntity = {
  token: "cat_apparel-women",
  type: "category",
  name: "Women",
  level: 2,
  parentToken: "cat_apparel",
  href: "/category/apparel/women",
  childCategoryTokens: [
    "cat_women-all",
    "cat_women-activewear",
    "cat_women-costumes",
    "cat_women-dresses",
    "cat_women-intimates",
    "cat_women-jeans",
    "cat_women-jumpsuits",
    "cat_women-kimonos",
    "cat_women-sweaters",
    "cat_women-loungewear",
    "cat_women-matching-sets",
    "cat_women-maternity",
    "cat_women-outerwear",
    "cat_women-pants",
    "cat_women-plus-size",
    "cat_women-screen-printed",
    "cat_women-shirts-blouses",
    "cat_women-shorts",
    "cat_women-sleepwear",
    "cat_women-socks",
    "cat_women-suits",
    "cat_women-sweatshirts",
    "cat_women-swimwear",
    "cat_women-tshirts",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
